/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_ActionInputs */

const th_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทางลัด`)
};

const en_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick action`)
};

const ja_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クイック操作`)
};

const zh_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快捷操作`)
};

const es_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acción rápida`)
};

const pt_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ação rápida`)
};

const id_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aksi cepat`)
};

const fr_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action rapide`)
};

const tl_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mabilisang aksyon`)
};

const vi_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thao tác nhanh`)
};

const ko_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빠른 작업`)
};

const de_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnellaktion`)
};

const ru_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Быстрое действие`)
};

const tr_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hızlı işlem`)
};

const it_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azione rapida`)
};

const pl_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szybkie działanie`)
};

const uk_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Швидка дія`)
};

const hi_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`त्वरित क्रिया`)
};

const ar_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجراء سريع`)
};

const ms_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tindakan pantas`)
};

const bn_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দ্রুত কাজ`)
};

const zh_tw2_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快速操作`)
};

const zh_hk2_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快速操作`)
};

const ur_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فوری کارروائی`)
};

const fa_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کار سریع`)
};

const sw_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kitendo cha haraka`)
};

const nl_quick_action = /** @type {(inputs: Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snelle actie`)
};

/**
* | output |
* | --- |
* | "Quick action" |
*
* @param {Quick_ActionInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const quick_action = /** @type {((inputs?: Quick_ActionInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_ActionInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_quick_action(inputs)
	if (locale === "ja") return ja_quick_action(inputs)
	if (locale === "zh") return zh_quick_action(inputs)
	if (locale === "es") return es_quick_action(inputs)
	if (locale === "pt") return pt_quick_action(inputs)
	if (locale === "id") return id_quick_action(inputs)
	if (locale === "fr") return fr_quick_action(inputs)
	if (locale === "tl") return tl_quick_action(inputs)
	if (locale === "vi") return vi_quick_action(inputs)
	if (locale === "ko") return ko_quick_action(inputs)
	if (locale === "de") return de_quick_action(inputs)
	if (locale === "ru") return ru_quick_action(inputs)
	if (locale === "tr") return tr_quick_action(inputs)
	if (locale === "it") return it_quick_action(inputs)
	if (locale === "pl") return pl_quick_action(inputs)
	if (locale === "uk") return uk_quick_action(inputs)
	if (locale === "hi") return hi_quick_action(inputs)
	if (locale === "ar") return ar_quick_action(inputs)
	if (locale === "ms") return ms_quick_action(inputs)
	if (locale === "bn") return bn_quick_action(inputs)
	if (locale === "zh-TW") return zh_tw2_quick_action(inputs)
	if (locale === "zh-HK") return zh_hk2_quick_action(inputs)
	if (locale === "ur") return ur_quick_action(inputs)
	if (locale === "fa") return fa_quick_action(inputs)
	if (locale === "sw") return sw_quick_action(inputs)
	if (locale === "nl") return nl_quick_action(inputs)
	return en_quick_action(inputs)
});